import { render, staticRenderFns } from "./plusIntranetBusinessTabIndex.vue?vue&type=template&id=95725a84"
import script from "./plusIntranetBusinessTabIndex.vue?vue&type=script&lang=js"
export * from "./plusIntranetBusinessTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports